/* global google, GMaps */
import venuesSliderTable from './modules/venuesSliderTable';

export default {
  init() {

  },
  finalize() {
    const locationMapSection = $('.section-venue-location-map');
    if (locationMapSection.length) {
      const mapDiv = locationMapSection.find('#map');
      if (mapDiv.length) {
        const title = mapDiv.data('title');
        const address = mapDiv.data('address');
        const locationLat = mapDiv.data('lat');
        const locationLng = mapDiv.data('lng');
        const markerUrl = mapDiv.data('marker-url');
        const radius = mapDiv.data('radius');
        const infoWindowTemplate = locationMapSection.find('#map-marker-info-window').html();

        const transformMapInfo = function(data, template) {
          const keys = [];
          const values = [];

          $.each(data, function (key, value) {
            keys.push(key);
            values.push(value);
          });

          for (let i = 0; i < keys.length; i++) {
            template = template.replace(new RegExp('--' + keys[i] + '--', 'g'), values[i]);
          }

          return template;
        };

        const map = new GMaps({
          div: '#map',
          scrollwheel: false,
          lat: locationLat,
          lng: locationLng,
          zoom: 10,
        });

        map.addMarker({
          lat: locationLat,
          lng: locationLng,
          title: title,
          icon: {
            scaledSize: new google.maps.Size(26, 26),
            url: markerUrl,
          },
          infoWindow: {
            'content': transformMapInfo({
              name: title,
              address: address,
            }, infoWindowTemplate),
          },
          click() {
            setTimeout(() => {
              // Remove info window arrow
              const gmStyleIw = $('.gm-style-iw');
              const gmArrow = gmStyleIw.prev().find('div').eq(2);
              gmArrow.parent().find('div').eq(0).hide();
              gmArrow.hide();
            }, 10);
          },
        });

        const circle = new google.maps.Circle({
          strokeColor: '#871c3c',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#871c3c',
          fillOpacity: 0.2,
          map: map.map,
          center: {
            lat: locationLat,
            lng: locationLng,
          },
          radius: radius * 1000,
        });

        map.map.fitBounds(circle.getBounds());
      }
    }

    venuesSliderTable();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelVenue.js